import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

// The spreadsheet "formula" mark, drawn as strokes so it sits in the same
// boxes and colours as the MUI icons around it.
const FxIcon = (props) => (
  <SvgIcon {...props}>
    <g fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12.5 4.6c-1.7-.6-3.4.1-3.8 2L6.4 17.6c-.4 1.9-1.9 2.6-3.4 2" />
      <path d="M5 10h6" />
      <path d="M13.5 11l6 8M20 11l-7 8" />
    </g>
  </SvgIcon>
);

export default FxIcon;
